/**
 * CSS class used to unmask elements in Microsoft Clarity session recordings.
 * Add this class to elements that should be visible in Clarity when using strict masking mode.
 * Configure the Clarity UI to unmask elements matching this class.
 */
export const CLARITY_UNMASK_CLASS = 'data-clarity-unmask';
